export enum EmptyStateType {
  myNewsfeedNoArticles = 'my-newsfeed-no-articles',
  pageNoArticles = 'page-no-articles',
}
